import { C } from "../../constants/theme";
import { useColarLink } from "../../hooks/useColarLink";
import { BotaoColarLink } from "./BotaoColarLink";

// "Link do MakerWorld" + botão "Importar do link": usado nos pop-ups de registrar
// produto e de adicionar/editar item do orçamento. O campo é texto livre (fica
// gravado junto do produto/item); o botão abre a importação, que traz as fotos.
// Estilo neutro de propósito (funciona dentro dos dois sistemas de formulário).
// Só é montado com o pop-up aberto, então o Ctrl+V vale enquanto ele existe.
export function CampoLinkMakerWorld({ valor, onChange, onImportar, desabilitado }) {
  const link = (valor || "").trim();
  const valido = /^https?:\/\/\S+$/i.test(link);
  const colar = useColarLink(onChange, { ativo: !desabilitado });
  return (
    <div>
      <label style={{ display:"block", color:C.muted, fontSize:12, fontWeight:600, letterSpacing:.5, marginBottom:6 }}>
        Link do MakerWorld <span style={{ fontWeight:400 }}>(opcional)</span>
      </label>
      <div style={{ display:"flex", gap:8, alignItems:"stretch" }}>
        <input type="url" value={valor || ""} onChange={e => onChange(e.target.value)} placeholder="https://makerworld.com/pt/models/…"
          aria-label="Link do MakerWorld" disabled={desabilitado}
          style={{ flex:1, minWidth:0, background:C.panel, border:"1px solid " + (link && !valido ? C.danger : C.border), borderRadius:8, color:C.text, padding:"9px 12px", fontSize:13, outline:"none", boxSizing:"border-box" }} />
        <BotaoColarLink colar={colar} desabilitado={desabilitado} />
        <button type="button" onClick={onImportar} disabled={desabilitado}
          title="Traz as fotos do modelo e guarda o link"
          style={{ flexShrink:0, background:"transparent", border:"1.5px solid " + C.accent2, color:C.accent2, borderRadius:8, padding:"0 14px", fontSize:13, fontWeight:700, cursor:desabilitado ? "default" : "pointer", opacity:desabilitado ? .5 : 1 }}>
          Importar do link
        </button>
      </div>
      {link && !valido && <p role="alert" style={{ margin:"6px 0 0", color:C.danger, fontSize:12 }}>O link precisa começar com https://</p>}
      <p style={{ margin:"6px 0 0", color:C.muted, fontSize:11.5 }}>Copiou o link? Ctrl+V aqui dentro já cola. “Importar do link” traz as fotos do modelo; o link fica salvo mesmo sem importar.</p>
    </div>
  );
}
